import { Injectable,inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class SystemSettingsService {
  private apiUrl = environment.apiUrl + '/system_settings/';  // Usa la variable global
  private http = inject(HttpClient); // Inyección sin constructor

  get():Observable<any>{
    return this.http.get(this.apiUrl+'get')
  }
  save(userData: any): Observable<any> {
    return this.http.post(this.apiUrl+ 'save/', userData);
  }
}


